// Training is a separate host; API authorization is enforced by the server.
export const trainingSite = typeof window !== 'undefined' && /^(training\.hax\.ma|training\.localhost)$/.test(window.location.hostname);
export const gymSite = typeof window !== 'undefined' && (
  /^(gym\.hax\.ma|gym\.localhost)$/.test(window.location.hostname)
  || window.location.pathname === '/gym'
  || new URLSearchParams(window.location.search).get('gym') === '1'
);
let handler = null;
let latest = null;
const listeners = new Set();
export function installTrainingHandler(value) { handler = value; }
export function trainingCommand(action, payload) {
  if (!handler) throw new Error('The replay engine is still loading.');
  return handler(action, payload);
}
export function emitTrainingState(state) {
  latest = state;
  listeners.forEach(listener => listener(state));
}
export function subscribeTraining(listener) {
  listeners.add(listener);
  if (latest) listener(latest);
  return () => listeners.delete(listener);
}
